export default {
  Gradebook: "Boletín de notas",
  Gradebooks: "Boletines de notas",
};
